export default {
    id: 'navFor',
    config: {
        options: {
            navFor: null
        }
    },
    busSubscribe
}

function busSubscribe() {
    this.bus.postUpdate.subscribe(update.bind(this))
}

function update() {
    if (!this.config.options.navFor || !this.state.initialised) {
        return
    }

    const navFor = this.config.options.navFor

    if (
        this.config.options.navFor.config.options.infiniteSlide &&
        this.pluginState.infiniteSlide &&
        this.pluginState.infiniteSlide.appliedReducedAnimation &&
        navFor.pluginState.infiniteSlide.appliedReducedAnimation
    ) {
        return
    }

    let change = this.state.currentSlide - navFor.state.currentSlide
    navFor.events.changeSlide.next(change)
}
